var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_167_553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.919 116C25.8429 115.938 -0.0497938 89.973 7.19046e-05 57.9129C0.0499376 25.8402 26.0175 -0.0622131 58.0686 0.000112238C90.1572 0.0624376 116.037 26.0023 115.988 58.0749C115.938 90.1475 89.9577 116.062 57.919 116ZM5.85929 57.8131C5.69722 86.4953 28.8848 109.892 57.6946 110.117C86.5045 110.341 109.979 87.0936 110.141 58.1746C110.303 29.48 87.1403 6.108 58.3055 5.87116C29.5081 5.64679 6.02135 28.9066 5.85929 57.8131Z",
    fill: "#3054B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2782 74.8404C65.9727 75.0897 72.5924 78.0813 77.7285 84.1642C79.399 86.1462 79.4738 88.0284 77.9155 89.1129C76.0082 90.4466 74.5995 89.5242 73.2406 87.991C64.6637 78.2932 51.2997 78.2682 42.7977 87.9038C41.0648 89.8608 39.3569 90.2597 37.9482 89.0256C36.527 87.7791 36.6517 86.0839 38.3471 84.0271C43.022 78.3306 50.5642 74.803 59.2907 74.8279L59.2782 74.8404Z",
    fill: "#3054B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8913 59.7077C29.0588 59.3213 27.1888 59.0471 25.3937 58.4986C23.7606 58 23.0126 56.6663 23.4614 55.0084C23.9102 53.3505 25.2441 52.5154 26.8896 52.9891C31.2155 54.2356 35.1424 53.3132 38.9696 51.2315C40.6775 50.2966 42.2358 50.6706 43.1334 52.4531C43.9686 54.1358 43.3453 55.6815 41.6997 56.3546C38.2465 57.7632 34.6936 58.8975 31.1781 60.144C31.0783 59.9944 30.9911 59.8449 30.8913 59.7077Z",
    fill: "#3054B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8467 60.1565C81.3311 58.91 77.7782 57.7881 74.3375 56.3796C72.5922 55.6691 71.9689 54.0486 72.9537 52.291C73.8637 50.6706 75.3971 50.3465 76.9804 51.2066C80.7951 53.2882 84.7095 54.2356 89.0354 53.0015C90.6809 52.5279 92.0148 53.3381 92.4886 54.971C92.9748 56.6289 92.2392 57.9626 90.6186 58.4737C88.8359 59.0346 86.966 59.2964 85.1334 59.6953C85.0337 59.8449 84.9464 59.9944 84.8467 60.144V60.1565Z",
    fill: "#3054B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_167_553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 116,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.26805018e08dd6c62c7a0fc3e2201c9d.svg";
export { ForwardRef as ReactComponent };